<template>
  <v-alert class="alert-error" type="error" v-show="errorMessage" data-cy="alert-error"><span v-html="errorMessage"></span></v-alert>
</template>

<script>
/**
 * A Vuetify alert set to type "error"
 * Error message is shown as unescaped HTML to allow html responses from the auth API
 */
export default {
  name: 'AlertError',
  props: {
    /**
     * The message to display
     */
    errorMessage: {
      type: String
    }
  }
}
</script>

<style>
/**
Underline links in html error messages
 */
  .alert-error .v-alert__content a {
    color: white;
    text-decoration: underline;
  }
</style>
